import React from 'react'
import PropTypes from 'prop-types'

import { VictoryChart, VictoryBar} from 'victory'

import Paper from 'material-ui/Paper'
import { withStyles } from 'material-ui/styles'
import Grid from 'material-ui/Grid'
import Table, { TableBody, TableCell, TableRow } from 'material-ui/Table'
import Enum from 'swift-enum'
import Divider from 'material-ui/Divider'

import {createSelector} from 'reselect'
import {
  acttasksSelector, 
  acttaskByStatusSelector, 
  lastFinishDateSelector,
  furthestAheadSelector,
  furthestBehindSelector,
  mostCriticalSelector
} from '../selectors/dataset'
import * as f from '../etc/formatters'

import PercentageGraph from './PercentageGraph'
import ItemToolbar from './ItemToolbar'
import {chartColors, chartSizes } from '../etc/theme'

let _categoryShape = PropTypes.shape({
  total: PropTypes.number
})

let _chartShape = PropTypes.shape({
  notstarted_onschedule: _categoryShape,
  notstarted_behindschedule: _categoryShape,
  started_onschedule: _categoryShape,
  started_behindschedule: _categoryShape,
  complete: _categoryShape
})

export let detailedDescSelector = createSelector(
  lastFinishDateSelector,
  furthestAheadSelector,
  furthestBehindSelector,
  mostCriticalSelector,
  (
    last_finish_date,
     furthest_ahead,
     furthest_behind,
     most_critical

    ) => (
    <Table>
    <TableBody>
      <TableRow>
        <TableCell>Estimated delivery date</TableCell>
        <TableCell>{f.dateFormatter(last_finish_date)}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell>Days remaining to completion</TableCell>
        <TableCell>{f.daysFromNow(last_finish_date)}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell>Task furthest behind</TableCell>
        <TableCell>{furthest_ahead ? furthest_ahead.name : '- None found -'}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell>Task furthest ahead</TableCell>
        <TableCell>{furthest_behind ? furthest_behind.name  : '- None found -'}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell>Most critical task</TableCell>
        <TableCell>{most_critical ? most_critical.name  : '- None found -'}</TableCell>
      </TableRow>

    </TableBody>
  </Table>
  )
)

let completionDataSelector = createSelector(
  acttaskByStatusSelector,
  (by_status) => (
    [
      {x: 'Not Started', y: by_status.notstarted_onschedule.all.length + by_status.notstarted_behindschedule.all.length},
      {x: 'Started', y: by_status.started_onschedule.all.length    + by_status.started_behindschedule.all.length},
      {x: 'Complete', y: by_status.complete.all.length}
    ]
  )
)

let percentageSelector = createSelector(
  acttasksSelector,
  acttaskByStatusSelector,
  (all_tasks, by_status) => (by_status.complete.all.length / (all_tasks.length))
)

class Filter extends Enum {}
Filter.case({none: ''})
Filter.freeze()

const defaultFilter = Filter.none
export {Filter, defaultFilter}

export let taglineSelector= dataset => ""

export let MainChart = ({dataset, currentFilter, onSetFilter, radius, width, height, ...rest}) => (
  <PercentageGraph 
    colors={chartColors.project_status} 
    value={percentageSelector(dataset)} 
    radius={radius}
    {...rest}
   />
)  

let _Homepage = ({classes, dataset, filter, onSetFilter, currentFilter, ...rest}) => (
  <div className={classes.root} {...rest}>
    <MainChart 
      dataset={dataset} 
      onSetFilter={onSetFilter}
      currentFilter={currentFilter}
      radius={chartSizes.radius.large}
      className={classes.mainChart}
    />
    <Divider light/>
    <div style={{width: chartSizes.width.large, height: chartSizes.height.large} }>
      <VictoryChart width={300} height={200}>
        <VictoryBar
          width={300} height={200}
          data={completionDataSelector(dataset)}
          domainPadding={{x: [10, 15], y: 5}}

        />
      </VictoryChart>
    </div>
    <Divider light/>
    {detailedDescSelector(dataset)}
  </div>
)

let styles = theme => ({
  root: theme.mixins.gutters({
    paddingTop: 0,
    paddingBottom: 16,
    overflowX: 'auto',
  }),
  mainChart: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  legend : {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
    marginLeft: 'auto',
    marginRight: 'auto'
  }
})


export let Homepage = withStyles(styles)(_Homepage)



// WEBPACK FOOTER //
// ./src/components/TaskCompletion.js